import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import EventSectionTabs, { EVENT_TAB_DASHBOARD } from "../components/EventSectionTabs";
import SectionTabsPageHeader from "../components/SectionTabsPageHeader";
import RegistrationMetrics from "./RegistrationMetrics";
import ClosedEventsMetrics from "./ClosedEventsMetrics";

const TAB_REGISTRATION = "registrationMetrics";
const TAB_CLOSED_EVENTS = "closedEventsMetrics";
const VALID_TABS = [TAB_REGISTRATION, TAB_CLOSED_EVENTS];
const DEFAULT_TAB = TAB_REGISTRATION;

function EventDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const activeTab =
    tabFromUrl && VALID_TABS.includes(tabFromUrl) ? tabFromUrl : DEFAULT_TAB;

  useEffect(() => {
    if (!tabFromUrl || !VALID_TABS.includes(tabFromUrl)) {
      setSearchParams({ tab: activeTab }, { replace: true });
    }
  }, [tabFromUrl, activeTab, setSearchParams]);

  return (
    <div className="page-container page-container-full page-container--section-tabs">
      <SectionTabsPageHeader subtitle="Registration metrics and closed events metrics in one place.">
        <EventSectionTabs activeTab={EVENT_TAB_DASHBOARD} />
      </SectionTabsPageHeader>
      <div className="tabs-bar">
        <div className="tabs-list">
          <button
            type="button"
            className={`tab-btn ${activeTab === TAB_REGISTRATION ? "active" : ""}`}
            onClick={() => setSearchParams({ tab: TAB_REGISTRATION })}
          >
            Registration Metrics
          </button>
          <button
            type="button"
            className={`tab-btn ${activeTab === TAB_CLOSED_EVENTS ? "active" : ""}`}
            onClick={() => setSearchParams({ tab: TAB_CLOSED_EVENTS })}
          >
            Closed Events Metrics
          </button>
        </div>
      </div>
      <div className="tab-content">
        {activeTab === TAB_REGISTRATION && <RegistrationMetrics />}
        {activeTab === TAB_CLOSED_EVENTS && <ClosedEventsMetrics />}
      </div>
    </div>
  );
}

export default EventDashboard;
